import React, { Component } from 'react';
import { Switch, Route, Link } from 'react-router-dom';
import BotResponsesMainTab from './BotResponsesMainTab';
import Translations from './Translations';
import EntitiesMainTab from './EntitiesMainTab';
import Substitutions from './Substitutions';
import $ from 'jquery';
import AbbreviationText from './AbbreviationText';
import DialogDirective from './Sub-tabs-Dialog-Directives';

class MultiLingualTabs extends Component {
  componentDidMount() {
    (function () {
      var currentPath = window.location.href;
      var currentPath = window.location.href;
      var path = window.origin + "/platform/projectmgmt/multilingual";
      var path1 = window.origin + "/platform/projectmgmt/multilingual/";
      if (currentPath === path || currentPath === path1) {
        $("#entities-tab").addClass('active');
      } else if (currentPath.includes('/multilingual/Translations')) {
        $("#translation-tab").addClass('active');
      } else if (currentPath.includes('/multilingual/substitution')) {
        $("#substitution-tab").addClass('active');
      } else if (currentPath.includes('/multilingual/responses')) {
        $("#mlt-tab").addClass('active');
      } else if (currentPath.includes('/responses/dialog-directives')) {
        $("#dialog-directive-tab").addClass('active');
      } else if (currentPath.includes('/multilingual/abbreviation')) {
        $("#abbreviation-tab").addClass('active');
      } else {
        $("#" + localStorage.getItem("last-multilingual-data-tab")).addClass('active')
      }
      $("#entities-tab,#translation-tab,#substitution-tab,#mlt-tab,#abbreviation-tab,#dialog-directive-tab")
        .on("click", function () {
          $("#entities-tab,#translation-tab,#substitution-tab,#mlt-tab,#abbreviation-tab,#dialog-directive-tab")
            .removeClass('active');
          localStorage.setItem("last-multilingual-data-tab", $(this)[0].id);
          $(this).addClass('active')

        })

      $("#entities-tab").on("click", function () {
        $("#mlcd-tab,#named-entity-tab,#custom-entity-type-tab")
          .removeClass('active');
        $("#mlcd-tab").addClass('active');
      })

      $("#mlt-tab").on("click", function () {
        $("#mlt1-tab,#pre-escalation-tab,#support-unavailable-tab")
          .removeClass('active');
        $("#mlt1-tab").addClass('active');
      })

      $("#dialog-directive-tab").on("click", function () {
        $("#incoming-dialog-directive-tab,#outgoing-dialog-directive-tab")
          .removeClass('active');
        $("#incoming-dialog-directive-tab").addClass('active');
      })

    })();
  }
  render() {
    return (
      <div id="tabPage" >
        <div className="content" >

          <link rel="shortcut icon" type="image/png" href="assets/images/bot.ico" />
          <title> Dheeyantra | Clusters Details</title>
          {/* Font Awesome Icons */}
          <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />
          {/* IonIcons */}
          <link rel="stylesheet" href="//code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css" />
          <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
          {/* Theme style */}
          <link rel="stylesheet" href="assets/css/adminlte.css" />
          <link href="https://cdn.jsdelivr.net/npm/gijgo@1.9.6/css/gijgo.min.css" rel="stylesheet" />
          <link rel="stylesheet" href="assets/css/custom-style.css" />
          <link rel="stylesheet" href="assets/css/styles.css" />
          <link rel="stylesheet" href="assets/css/custom-style.css" />
          <div className="content-header" >
            <div className="container-fluid">
              <div className="row">
                <div className="col-sm-5">
                  <h1 className="m-0 page-title">Entities &amp; Other Data</h1>
                  <h6 className="taglineTxt">Multilingual support for entities and responses</h6>
                </div>
              </div>
            </div>
          </div>
          <div className="container-fluid">
            <div className="border-bottom"></div>
            {/* Nav tabs */}
            <div className="tab-class">

              <ul className="nav nav-tabs border-bottom navCluster">
                <Link className="nav-item" data-toggle="tab"
                  to="/projectmgmt/multilingual" style={{ textDecoration: 'none' }} >
                  <li className="nav-link" id="entities-tab">
                    Entities
                  </li>
                </Link>


                <Link className="nav-item" data-toggle="tab"
                  to="/projectmgmt/multilingual/responses" style={{ textDecoration: 'none' }} >
                  <li className="nav-link" id="mlt-tab">
                    Agent Responses
                  </li>
                </Link>
                <Link to="/projectmgmt/multilingual/dialog-directives" className="nav-item" data-toggle="tab"
                  style={{ textDecoration: 'none' }}>
                  <li className="nav-link" id="dialog-directive-tab">
                    Directive Utterances
                  </li>
                </Link>
                <Link className="nav-item" data-toggle="tab"
                  to="/projectmgmt/multilingual/Translations" style={{ textDecoration: 'none' }}>
                  <li className="nav-link" id="translation-tab">
                    Translations
                  </li>
                </Link>

                <Link to="/projectmgmt/multilingual/substitution" style={{ textDecoration: 'none' }}
                  className="nav-item" data-toggle="tab"
                >
                  <li className="nav-link" id="substitution-tab">
                    Query Substitutions
                  </li>
                </Link>
                <Link to="/projectmgmt/multilingual/abbreviation" style={{ textDecoration: 'none' }}
                  className="nav-item" data-toggle="tab">
                  <li className="nav-link" id="abbreviation-tab">
                    Abbreviation Text
                  </li>
                </Link>

              </ul>
            </div>
          </div>
        </div>

        <Switch >
          <Route path="/projectmgmt/multilingual/abbreviation" component={AbbreviationText}></Route>
          <Route path="/projectmgmt/multilingual/substitution" component={Substitutions}></Route>
          <Route path="/projectmgmt/multilingual/responses" component={BotResponsesMainTab}></Route>
          <Route path="/projectmgmt/multilingual/Translations" component={Translations}></Route>
          <Route path="/projectmgmt/multilingual/dialog-directives" component={DialogDirective}></Route>
          <Route path="/projectmgmt/multilingual" component={EntitiesMainTab}></Route>

        </Switch>

      </div>
    );
  }
}
export default MultiLingualTabs;


// WEBPACK FOOTER //
// ./src/projectmgmt/MultiLingualData/MultiLingualTabs.js